import MainPage from "./components/MainPage";
export default MainPage;
